export default __webpack_public_path__ + "static/media/servicio-8.241d1c96.webp";